import Icon from '../components/Icon.vue'

Icon.register({"circle":{"width":512,"height":512,"paths":[{"d":"M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/circle.js
// module id = pYLg
// module chunks = 0